var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "plans-wrapper" }, [
    _c("div", { staticClass: "plans-wrapper-title" }, [
      _vm._v(_vm._s(_vm.$t("billing.additionalPackages"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "plans-wrapper-content" },
      _vm._l(_vm.getFeaturePlans(), function (featurePlan) {
        return _c("FeaturePlan", {
          key: featurePlan._id,
          attrs: {
            plan: featurePlan,
            "is-selected": _vm.isSelected(featurePlan),
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }